import { movimientosDB } from './index'

export async function registrarEntrada(productoId, productoNombre, stockAnterior, stockNuevo) {
  await movimientosDB.put({
    _id: `mov_${Date.now()}_${Math.random().toString(36).slice(2, 5)}`,
    tipo: 'entrada',
    productoId,
    productoNombre,
    cantidad: stockNuevo - stockAnterior,
    stockAnterior,
    stockNuevo,
    fecha: new Date().toISOString(),
  })
}

export async function registrarSalida(productoId, productoNombre, cantidad, stockAnterior, stockNuevo, ventaId) {
  await movimientosDB.put({
    _id: `mov_${Date.now()}_${Math.random().toString(36).slice(2, 5)}`,
    tipo: 'salida',
    productoId,
    productoNombre,
    cantidad,
    stockAnterior,
    stockNuevo,
    ventaId,
    ventaFolio: 'PJ-' + ventaId.slice(-6).toUpperCase(),
    fecha: new Date().toISOString(),
  })
}

export async function obtenerMovimientosInventario(dias = null) {
  let endkey = 'mov_'

  if (dias !== null) {
    const desde = new Date()
    desde.setDate(desde.getDate() - dias)
    desde.setHours(0, 0, 0, 0)
    endkey = `mov_${desde.getTime()}`
  }

  const result = await movimientosDB.allDocs({
    include_docs: true,
    descending: true,
    startkey: 'mov_￿',
    endkey,
  })
  return result.rows.map(r => r.doc)
}
